<template>
  <div class="workshop">
    <div class="part1 clearfix auto_1280">
      <div class="left">
        <div class="title">{{content.title}}</div>
        <div class="txt">{{content.intro}}</div>
        <div class="qrcode">
          <img :src="content.content" alt="">
          <pre v-if="lan === 0">{{text}}</pre>
          <pre v-else-if="lan === 1">{{enText}}</pre>
        </div>
      </div>
      <div class="right">
        <img :src="content.coverImg" alt="">
        <!-- <svg width:="0" height="0">
          <defs>
            <clipPath id="svgPath" clipPathUnits="objectBoundingBox" transform="scale(0.0017452006980803, 0.0018315018315018)">
              <path fill="rgb(228, 0, 127)" opacity="0.149" fill-rule="evenodd" stroke="#000000" stroke-width="1.5794" stroke-miterlimit="10" d="M27.967,327.074 C27.967,327.074 53.947,379.133 108.689,412.472 C163.431,445.810 195.256,453.602 267.059,465.557 C338.862,477.512 415.280,488.077 464.637,461.710 C513.994,435.343 538.848,388.836 536.134,313.996 C533.420,239.155 527.082,188.996 502.307,132.430 C477.533,75.864 439.451,37.275 416.203,19.336 C392.956,1.396 353.825,-9.297 270.134,15.489 C186.444,40.275 139.582,55.866 95.620,78.576 C51.658,101.285 10.960,118.412 3.366,180.129 C-4.229,241.847 2.862,280.121 27.967,327.074 Z" />
            </clipPath>
          </defs>
        </svg> -->
      </div>
    </div>
    <div class="part2">
      <div class="auto_1280">
        <div class="tit" v-if="content.tag !== 'true'">{{content.tag}}</div>
        <ul class="ul clearfix">
          <li v-for="( item, index ) in workshopList" :key="index" @click="goDetail(item.id)" class="clearfix">
            <div class="box">
              <div class="pic bg_cover"  :style="'background-image: url(' + item.coverImg + ')'">
                <div class="cover" v-if="item.isUpload === 1"><span class="icon"></span></div>
              </div>
              <div class="content">
                <!-- <div class="date">
                  <div class="day">{{item.createTime | day}}</div>
                  <div class="ym">{{item.createTime | ym}}</div>
                </div> -->
                <div class="title1 dot">{{item.title}}</div>
                <div class="txt1 dot2">{{item.intro}}</div>
                <!-- <div class="more" v-if="lan === 0">了解更多</div> -->
                <!-- <div class="more" v-else-if="lan === 1">Learn More</div> -->
              </div>
            </div>
          </li>
        </ul>
        <div class="pager" v-if="workshopList.length > 0">
          <span class="p_page">
            <a @click="pageIndex = ( pageIndex == 1 ? 1 : pageIndex - 1 );" class="a_prev" :class="{disable_prev: pageIndex == 1}"></a>
            <em class="num">
              <template v-for="( num, index ) in pageList">
                <a @click="pageIndex = num;" :key="index" :class="[ num == pageIndex ? 'a_cur' : '' ]">{{num}}</a>
              </template>
            </em>
            <a @click="pageIndex = ( pageIndex == maxPageIndex ? maxPageIndex : pageIndex + 1 );" class="a_next" :class="{disable_next: pageIndex == maxPageIndex}"></a>
          </span>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
export default {
  name: 'Workshop',
  filters: {
    day (value) {
      const date = new Date(value)
      return ('0' + date.getDate()).slice(-2)
    },
    ym (value) {
      const date = new Date(value)
      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      return year + '.' + month
    }
  },
  data () {
    return {
      workshopList: [],
      content: {},
      articleTypeId: 12,
      pageList: [],
      pageIndex: 1,
      pageSize: 6,
      total: 0,
      maxPageIndex: 1,
      lan: this.$store.state.isEn,
      text: '长按识别二维码\n了解更多非遗好物',
      enText: 'Long press the QR code\nTo learn more about intangible cultural heritage'
    }
  },
  watch: {
    pageIndex (val, oldval) {
      if (val !== oldval) {
        this.initList()
      }
    },
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      if (this.pageIndex !== 1) {
        this.pageIndex = 1
      } else {
        this.init()
        this.initList()
      }
    }
  },
  mounted () {
    console.log('2')
    localStorage.removeItem('path')
    localStorage.removeItem('columnId')
    const self = this
    self.initId()
    self.init()
    this.initList()
  },
  activated () {
    this.initId()
  },
  methods: {
    initId () {
      // 获取当前栏目的栏目id，用于当前栏目的数据获取
      const self = this
      // let menuList
      // try {
      //   console.log('routeList', JSON.parse(localStorage.getItem('menuList')))
      //   menuList = JSON.parse(localStorage.getItem('routeList'))
      // } catch (e) {
      //   console.log(e)
      // }
      // const id = parseInt(self.$route.query.columnId)
      // const index = self.$route.path.lastIndexOf('/')
      // const path = self.$route.path.substring(index + 1, self.$route.path.length)
      // menuList.forEach((item) => {
      //   if (id === item.id) {
      //     item.children.forEach((inner) => {
      //       if (inner.requestTo.toLowerCase() === path) {
      //         this.articleTypeId = inner.id
      //         this.$store.commit('changeId', inner.id)
      //       }
      //     })
      //   }
      // })
      this.$store.commit('changeId', self.articleTypeId)
    },
    init () {
      const self = this
      self.workshopList = []
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: self.articleTypeId, current: 1, pageSize: 1, bLanguage: this.lan, tag: 'true' }, r => {
        if (r) {
          self.content = r.data[0]
        }
      })
    },
    initList () {
      const self = this
      self.workshopList = []
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: self.articleTypeId, current: self.pageIndex, pageSize: self.pageSize, bLanguage: this.lan }, r => {
        if (r.total && r.data) {
          self.total = r.total
          r.data.forEach((item) => {
            if (item.tag === '') {
              self.workshopList.push(item)
            }
          })
        }
        self.initPager()
      })
      self.$nextTick(function () {
        self.initEL()
      })
    },
    initPager () {
      const self = this
      const footerCount = 5
      self.pageList = []
      self.maxPageIndex = parseInt(self.total / self.pageSize) + (self.total % self.pageSize === 0 ? 0 : 1)
      let startPageIndex = self.pageIndex - parseInt(footerCount / 2)
      startPageIndex = startPageIndex < 1 ? 1 : startPageIndex
      for (let i = startPageIndex; i <= self.maxPageIndex; i++) {
        self.pageList.push(i)
        if (self.pageList.length >= footerCount) break
      }
    },
    initEL () {},
    goDetail (id) {
      const index = this.$route.path.lastIndexOf('/')
      // 用于从详情页跳回到列表页
      localStorage.setItem('path', this.$route.path.substring(index + 1, this.$route.path.length))
      localStorage.setItem('columnId', this.$route.query.columnId)
      this.$router.push({
        path: '/ruralvitalization/detail',
        query: {
          columnId: this.$route.query.columnId,
          articleTypeId: this.articleTypeId,
          id
        }
      })
    }
  }
}
</script>
<style scoped>
/* .workshop{overflow: hidden;} */
.workshop .part1{padding: 3% 0 6%;}
.workshop .left{width: 50%; float: left;}
.workshop .right{width: 50%; float: left;}
.workshop .left{padding-right: 15%; box-sizing: border-box;}
.workshop .left .title{font-size: 40px; color: #e4007f;}
.workshop .txt{font-size: 16px; line-height: 2; padding: 12% 0 15%;}
.workshop .right{
  /* background: url(../../assets/vlovebg.png)no-repeat center;  */
text-align: center; background-size: contain; position: relative;}
.workshop .right img{width: 80%; clip-path: url(#svgPath); -webkit-clip-path: url(#svgPath);}
.workshop .qrcode pre{display: inline-block; vertical-align: middle; padding-left: 5%; line-height: 1.8; font-size: 14px; color: #666; font-weight: lighter;}

.workshop .part2{background-color: #f8f8f8; overflow: hidden; padding-bottom: 5%; padding-top: 4%;}
.workshop .box{position: relative;}
.workshop .pic{float: right; width: 100%; padding-top: 65%; border-radius: 5px; position: relative;}
.workshop .pic .cover{position: absolute; left: 0; top: 0; opacity: 0; transition: all .3s; width: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,.4); display: flex; justify-content: center; align-items: center;}
.workshop .pic .icon{background: url(../../assets/play-icon.png)no-repeat center; width: 56px; height: 36px; display: inline-block; transition: all .3s;}
.workshop li:hover .cover{opacity: 1;}
.workshop .content{float: left; width: 100%; position: relative; padding: 2% 0;}
.workshop ul{margin: 0 -2%;}
.workshop li{padding: 0 2%; margin-bottom: 2%; cursor: pointer; float: left; width: 33.33%;}
.workshop .title1{font-size: 20px; color: #333; transition: all .3s;}
.workshop .txt1{font-weight: lighter; line-height: 1.8; min-height: 60px; color: #666; margin: 1% 0 3% 0; word-break: break-word; transition: all .3s;}
.workshop li:hover .title1{color: #e4007f;}
.workshop li:hover .txt1{color: #e4007dc4;}
.workshop .tit{font-size: 30px; padding: 2% 0 3% 0;}
@media(max-width: 960px){
  .workshop .left .title{font-size: 36px;}
  .workshop .left{padding-right: 10%;}
}
@media(max-width: 768px){
  .workshop .title1{font-size: 18px;}
}
@media(max-width: 640px){
  .workshop .left .title{font-size: 30px;}
  .workshop .left,
  .workshop .right{width: 100%; float: none;}
  .workshop .left{padding-right: 0;}
  .workshop .right img{width: 100%;}
  .workshop .right{padding-top: 5%;}
  .workshop li{width: 100%;}
  .workshop .part2 .txt1{min-height: 0;}

  .workshop .pic .cover{opacity: 1;}
}
</style>
